<div class="financial-dashboard">
  <div class="row mb-4 align-items-center">
    <div class="col-md-6">
      <h4>{{ 'KPI.FINANCIAL.TITLE' | translate }}</h4>
      <p class="text-muted mb-0">{{ 'KPI.FINANCIAL.SUBTITLE' | translate }}</p>
    </div>
  </div>

  <nb-card class="mb-4">
    <nb-card-body>
      <app-report-filter-bar
        [showStoreFilter]="false"
        [disabled]="filtersDisabled"
        (filterChange)="onFilterChange($event)"
        (exportRequested)="onExport($event)">
      </app-report-filter-bar>
      <div class="row align-items-end g-2 mt-3">
        <div class="col-md-3">
          <label class="form-label">{{ 'KPI.FINANCIAL.TRANSACTION_TYPE' | translate }}</label>
          <select class="form-control" [(ngModel)]="transactionType" (change)="onTransactionFilterChange()">
            <option *ngFor="let t of transactionTypes" [value]="t.value">{{ t.labelKey | translate }}</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">{{ 'KPI.FINANCIAL.PAYMENT_STATUS' | translate }}</label>
          <select class="form-control" [(ngModel)]="paymentStatus" (change)="onTransactionFilterChange()">
            <option *ngFor="let s of paymentStatuses" [value]="s.value">{{ s.labelKey | translate }}</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">{{ 'KPI.FINANCIAL.PAYMENT_METHOD' | translate }}</label>
          <select class="form-control" [(ngModel)]="paymentMethod" (change)="onTransactionFilterChange()">
            <option *ngFor="let m of paymentMethods" [value]="m.value">{{ m.value || (m.labelKey | translate) }}</option>
          </select>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <!-- Current Balance -->
  <div class="row mb-4">
    <div class="col-12 text-center py-4" *ngIf="loadingBalance">
      <nb-spinner size="medium"></nb-spinner>
    </div>
    <div class="col-md-3" *ngIf="currentBalance && !loadingBalance">
      <nb-card class="metric-card">
        <nb-card-body class="text-center">
          <h6 class="text-muted">{{ 'KPI.FINANCIAL.TOTAL_REVENUE' | translate }}</h6>
          <h4>{{ formatCurrency(currentBalance.totalRevenue) }}</h4>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-md-3" *ngIf="currentBalance && !loadingBalance">
      <nb-card class="metric-card">
        <nb-card-body class="text-center">
          <h6 class="text-muted">{{ 'KPI.FINANCIAL.COMMISSION' | translate }}</h6>
          <h4 class="text-warning">{{ formatCurrency(currentBalance.totalCommission) }}</h4>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-md-3" *ngIf="currentBalance && !loadingBalance">
      <nb-card class="metric-card">
        <nb-card-body class="text-center">
          <h6 class="text-muted">{{ 'KPI.FINANCIAL.NET_AMOUNT' | translate }}</h6>
          <h4 class="text-primary">{{ formatCurrency(currentBalance.netAmount) }}</h4>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-md-3" *ngIf="payoutEstimate && !loadingBalance">
      <nb-card class="metric-card">
        <nb-card-body class="text-center">
          <h6 class="text-muted">{{ 'KPI.FINANCIAL.PAYOUT_ESTIMATE' | translate }}</h6>
          <h4 class="text-success">{{ formatCurrency(payoutEstimate.estimatedAmount) }}</h4>
          <small class="text-muted d-block">{{ 'KPI.FINANCIAL.PENDING_TRANSACTIONS' | translate }}: {{ payoutEstimate.pendingTransactionsCount || 0 }}</small>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-md-3" *ngIf="currentBalance && !loadingBalance && !payoutEstimate">
      <nb-card class="metric-card">
        <nb-card-body class="text-center">
          <h6 class="text-muted">{{ 'KPI.FINANCIAL.PAYOUT_STATUS' | translate }}</h6>
          <nb-badge
            [status]="currentBalance.payoutStatus === 'paid' ? 'success' : 'warning'"
            [text]="(currentBalance.payoutStatus || 'pending') | titlecase">
          </nb-badge>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-12" *ngIf="!loadingBalance && !currentBalance">
      <nb-card>
        <nb-card-body class="text-center text-muted py-4">
          {{ 'KPI.FINANCIAL.NO_BALANCE' | translate }}
        </nb-card-body>
      </nb-card>
    </div>
  </div>

  <!-- Balance History -->
  <div class="row mb-4" *ngIf="loadingBalanceHistory || balanceHistory.length > 0">
    <div class="col-12">
      <nb-card>
        <nb-card-header>{{ 'KPI.FINANCIAL.BALANCE_HISTORY' | translate }}</nb-card-header>
        <nb-card-body>
          <div *ngIf="loadingBalanceHistory" class="text-center py-4">
            <nb-spinner size="medium"></nb-spinner>
          </div>
          <div class="table-responsive" *ngIf="!loadingBalanceHistory">
            <table class="table">
              <thead>
                <tr>
                  <th>{{ 'KPI.FINANCIAL.PERIOD' | translate }}</th>
                  <th class="text-end">{{ 'KPI.FINANCIAL.TOTAL_REVENUE' | translate }}</th>
                  <th class="text-end">{{ 'KPI.FINANCIAL.COMMISSION' | translate }}</th>
                  <th class="text-end">{{ 'KPI.FINANCIAL.NET_AMOUNT' | translate }}</th>
                  <th>{{ 'KPI.FINANCIAL.STATUS' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let entry of balanceHistory">
                  <td>{{ getMonthLabel(entry) }}</td>
                  <td class="text-end">{{ formatCurrency(entry.totalRevenue) }}</td>
                  <td class="text-end">{{ formatCurrency(entry.totalCommission) }}</td>
                  <td class="text-end">{{ formatCurrency(entry.netAmount) }}</td>
                  <td>
                    <nb-badge
                      [status]="entry.payoutStatus === 'paid' ? 'success' : 'basic'"
                      [text]="(entry.payoutStatus || '-') | titlecase">
                    </nb-badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </div>

  <!-- Filtered Totals Summary -->
  <nb-card class="mb-4" *ngIf="filteredTotals">
    <nb-card-header>{{ 'KPI.FINANCIAL.FILTERED_TOTALS' | translate }}</nb-card-header>
    <nb-card-body>
      <div class="row text-center">
        <div class="col-md-3">
          <div class="text-muted small">{{ 'KPI.FINANCIAL.TOTAL_AMOUNT' | translate }}</div>
          <strong>{{ formatCurrency(filteredTotals.totalAmount) }}</strong>
        </div>
        <div class="col-md-3">
          <div class="text-muted small">{{ 'KPI.FINANCIAL.TRANSACTION_COUNT' | translate }}</div>
          <strong>{{ filteredTotals.count || 0 }}</strong>
        </div>
        <div class="col-md-6" *ngIf="filteredTotals.byType">
          <div class="d-flex justify-content-around flex-wrap gap-2">
            <span>{{ 'KPI.FINANCIAL.BY_TYPE_SALE' | translate }}: {{ filteredTotals.byType.sale || 0 }}</span>
            <span>{{ 'KPI.FINANCIAL.BY_TYPE_REFUND' | translate }}: {{ filteredTotals.byType.refund || 0 }}</span>
            <span>{{ 'KPI.FINANCIAL.BY_TYPE_ADJUSTMENT' | translate }}: {{ filteredTotals.byType.adjustment || 0 }}</span>
            <span>{{ 'KPI.FINANCIAL.BY_TYPE_FEE' | translate }}: {{ filteredTotals.byType.fee || 0 }}</span>
          </div>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <!-- Transactions Table -->
  <nb-card>
    <nb-card-header>
      {{ 'KPI.FINANCIAL.TRANSACTION_HISTORY' | translate }}
      <span class="text-muted ms-2" *ngIf="totalTransactions">({{ totalTransactions }} {{ 'KPI.FINANCIAL.TOTAL' | translate }})</span>
    </nb-card-header>
    <nb-card-body>
      <div *ngIf="loadingTransactions" class="text-center py-4">
        <nb-spinner size="medium"></nb-spinner>
      </div>
      <div class="table-responsive" *ngIf="!loadingTransactions">
        <table class="table">
          <thead>
            <tr>
              <th>{{ 'KPI.FINANCIAL.DATE' | translate }}</th>
              <th>{{ 'KPI.FINANCIAL.TYPE' | translate }}</th>
              <th class="text-end">{{ 'KPI.FINANCIAL.GROSS' | translate }}</th>
              <th class="text-end">{{ 'KPI.FINANCIAL.COMMISSION' | translate }}</th>
              <th class="text-end">{{ 'KPI.FINANCIAL.NET_AMOUNT' | translate }}</th>
              <th class="text-end">{{ 'KPI.FINANCIAL.TAX' | translate }}</th>
              <th>{{ 'KPI.FINANCIAL.PAYMENT_STATUS' | translate }}</th>
              <th>{{ 'KPI.FINANCIAL.BALANCE_PERIOD' | translate }}</th>
              <th>{{ 'KPI.FINANCIAL.SETTLED' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tx of transactions">
              <td>{{ formatDate(tx.transactionDate) }}</td>
              <td>{{ tx.transactionType | titlecase }}</td>
              <td class="text-end">{{ formatCurrency(tx.grossAmount) }}</td>
              <td class="text-end">{{ formatCurrency(tx.commissionAmount) }}</td>
              <td class="text-end">{{ formatCurrency(tx.netAmount) }}</td>
              <td class="text-end">{{ formatCurrency(tx.taxAmount) }}</td>
              <td>{{ tx.paymentStatus || '-' }}</td>
              <td>{{ tx.balanceMonth }}/{{ tx.balanceYear }}</td>
              <td>
                <nb-badge [status]="tx.isSettled ? 'success' : 'basic'" [text]="tx.isSettled ? ('KPI.FINANCIAL.YES' | translate) : ('KPI.FINANCIAL.NO' | translate)"></nb-badge>
              </td>
            </tr>
            <tr *ngIf="transactions.length === 0">
              <td colspan="9" class="text-center text-muted py-4">{{ 'KPI.FINANCIAL.NO_TRANSACTIONS' | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="totalPages > 1">
        <span class="text-muted">{{ 'KPI.FINANCIAL.PAGE' | translate }} {{ currentPage }} {{ 'KPI.FINANCIAL.OF' | translate }} {{ totalPages }}</span>
        <div>
          <button class="btn btn-sm btn-outline-primary me-2" [disabled]="currentPage <= 1" (click)="onPageChange(currentPage - 1)">{{ 'KPI.FINANCIAL.PREVIOUS' | translate }}</button>
          <button class="btn btn-sm btn-outline-primary" [disabled]="currentPage >= totalPages" (click)="onPageChange(currentPage + 1)">{{ 'KPI.FINANCIAL.NEXT' | translate }}</button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</div>
